/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusCircleIcon20Light = forwardRef('PlusCircleIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 6a.5.5 0 0 0-1 0v3H6a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3V6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM3 9.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z" })));
});
